<article class="w-screen sm:w-28rem flex flex-column p-3 overflow-hidden relative">
  <section class="hidden gap-3 mb-2 fadein animation-duration-500"
    [ngClass]="{'flex flex-column': !showExp && !vehicleData}">
    <h4 class="w-fit text-xl md:text-2xl ci-txt--purple">
      Verificador de placa
    </h4>

    <section class="flex flex-column gap-3">
      <p class="md:text-lg ci-txt--black-lighten">
        Ingresa la placa de un taxi y comprueba si pertenece a <strong>Taxi Seguro</strong>
      </p>

      <form [formGroup]="form" class="w-full flex flex-column gap-3">
        <section class="w-full flex align-items-center border-round-xl border-1 border-gray-300">
          <input type="text" pInputText formControlName="plate" class="w-full" placeholder="Ejm: 1402DHR" />
        </section>

        <section class="w-full">
          <button [disabled]="form.invalid"
            class="w-full h-full ci-btn ci-btn--small ci-btn__purple flex justify-content-center align-items-center"
            (click)="verifyTaxi()" [ngClass]="{'ci-btn--disable': form.invalid}">
            <i class="bi bi-search mr-2"></i> Verificar
          </button>
        </section>
      </form>

      <section class="flex justify-content-end align-items-center">
        <small class="cursor-pointer" (click)="showExplanation()">
          ¿Que es Taxi seguro?
        </small>
      </section>
    </section>
  </section>

  <section class="hidden gap-3 mb-2 relative" [ngClass]="{'flex flex-column': showExp && !vehicleData}">
    <div class="w-full fadein animation-duration-500">
      <h4 class="w-fit text-xl md:text-2xl ci-txt--purple mb-3">
        ¿Que es Taxi seguro?
      </h4>

      <swiper-container slides-per-view="auto" pagination="true" pagination-dynamic-bullets="true"
        pagination-clickable="true">
        <swiper-slide *ngFor="let item of photos, index as i">
          <section
            class="w-20rem h-20rem mb-5 border-round-2xl mx-auto bg-contain bg-center bg-no-repeat border-round-xl overflow-hidden"
            style="background: url({{item}});">
          </section>
        </swiper-slide>
      </swiper-container>

      <section>
        <button class="w-full h-full ci-btn ci-btn--small ci-btn__grey ci-btn__grey--outline"
          (click)="showExplanation()">
          <i class="bi bi-arrow-left mr-2"></i> Volver
        </button>
      </section>
    </div>
  </section>

  <section class="hidden relative" [ngClass]="{'flex': vehicleData}">
    <section class="w-full flex flex-column gap-3 mt-3 fadeindown animation-duration-500">
      <section class="w-full flex flex-column align-items-center gap-2">
        <section class="w-full flex flex-column align-items-center relative">
          <i class="hidden bi bi-shield-fill-check ci-txt--green-lighten text-7xl mx-auto"
            [ngClass]="{'flex': vehicleData?.status}"></i>
          <i class="hidden bi bi-shield-fill-x ci-txt--red text-7xl mx-auto"
            [ngClass]="{'flex': !vehicleData?.status}"></i>

          <i class="bi bi-car-front ci-txt--purple text-6xl absolute bottom-0 ml-8"></i>
        </section>

        <h3 class="hidden text-center text-2xl ci-txt--black font-normal" [ngClass]="{'block': vehicleData?.status}">
          Vehículo <strong>registrado</strong> en <br> Taxi Seguro
        </h3>

        <h3 class="hidden text-center text-2xl ci-txt--black mb-4 font-normal"
          [ngClass]="{'block': !vehicleData?.status}">
          El vehículo <strong>NO</strong> pertenece <br> a Taxi Seguro, tenga precaución
        </h3>
      </section>

      <section *ngIf="vehicleData?.data && vehicleData?.status"
        class="w-full bg-black-alpha-10 border-round-xl p-3 mt-2 ci-txt--black-lighten">
        <swiper-container autoplay-delay="5000" class="w-full h-full" pagination="true"
          pagination-dynamic-bullets="true" pagination-clickable="true">

          <swiper-slide class="mb-5">
            <section>
              <h4 class="ci-txt--purple text-lg">
                Datos conductor
              </h4>

              <section class="w-6rem h-6rem border-circle shadow-1 overflow-hidden mt-3 bg-center bg-cover"
                [style.background]="getDriverPhoto(vehicleData.dataconductor[0].foto)">
              </section>

              <section class="w-full flex flex-column gap-3 mt-3">
                <div>
                  <strong class="mr-1 ci-txt--black">Nombre:</strong>
                  {{ getCapitalizeString(vehicleData.dataconductor[0].nombres) }}
                  {{ getCapitalizeString(vehicleData.dataconductor[0].apellido_paterno) }}
                  {{ getCapitalizeString(vehicleData.dataconductor[0].apellido_materno) }}
                </div>

                <div>
                  <strong class="mr-1 ci-txt--black">Afiliado:</strong> {{
                  getCapitalizeString(vehicleData.data.afiliado) }}
                </div>
              </section>
            </section>
          </swiper-slide>

          <swiper-slide class="mb-4">
            <section>
              <h4 class="ci-txt--purple text-lg">
                Datos vehículo
              </h4>

              <section class="w-full flex flex-column gap-3 mt-3">
                <div>
                  <strong class="mr-1 ci-txt--black">Placa:</strong> {{ vehicleData.data.placa }}
                </div>

                <div>
                  <strong class="mr-1 ci-txt--black">Clase:</strong> {{ getCapitalizeString(vehicleData.data.clase) }}
                </div>

                <div>
                  <strong class="mr-1 ci-txt--black">Marca:</strong> {{ getCapitalizeString(vehicleData.data.marca) }}
                  {{
                  vehicleData.data.modelo }}
                </div>

                <div>
                  <strong class="mr-1 ci-txt--black">Modelo:</strong> {{ getCapitalizeString(vehicleData.data.tipo) }}
                </div>

                <div>
                  <strong class="mr-1 ci-txt--black">Color:</strong> {{ getCapitalizeString(vehicleData.data.color) }}
                </div>
              </section>
            </section>
          </swiper-slide>
        </swiper-container>
      </section>

      <button class="w-full h-full ci-btn ci-btn--small ci-btn__purple ci-btn__purple--outline" (click)="reinitForm()">
        <i class="bi bi-arrow-repeat mr-2"></i> Volver a consultar
      </button>

      <button *ngIf="closeButton" class="w-full h-full ci-btn ci-btn--small ci-btn__purple" (click)="emitCloseEvent()">
        Cerrar
      </button>
    </section>
  </section>
</article>